<template>
  <span :class="{ 'error_input' : $v.value.$error }">
          <input
            :id="name"
            :name="name"
            :type="type"
            :validators="validators"
            :required="required"
            v-model="$v.value.$model"
            @change="containsError($v.value)"/>&nbsp;<span v-if="required">*</span>&nbsp;
            <label :for="name" class="terms-title" v-html="label"></label>
          <label v-if="this.required && $v.value.$dirty && !$v.value.checked" class="form__label-title error reset-left-padding">&nbsp; {{ $t('validations.required') }}</label>
      </span>
</template>
<script>
import OnboardInputMixin from '@/mixins/OnboardInputMixin';

export default {
  name: 'OnboardCheckboxInput',
  mixins: [OnboardInputMixin],
  mounted() {
    if (!this.required) {
      this.containsError(this.$v.value);
    }
  },
};
</script>
